import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";
import { setUserRefresh } from "./userSlice";

const initialState = {
    isLoading: false,
    isRefresh: false,
    wishlistData: {},
    addWishlistData: {},
    updateWishlistData: {},
    deleteWishlistData: {},
    addCartsData: {},
    errorMsg: "",
    isError: false
}


export const getAllWishlist = createAsyncThunk('getAllWishlist', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getAllWishlist();
        if (status === 200) {
            //get categories data
            dispatch(setAllWishlist(data.data))
        }
        return data.data
    } catch (err) {
        // Toastify.error(err.response.data.message)
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const addWishlist = createAsyncThunk('addWishlist', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.addWishlist(body);

        if (status === 200) {
            // render otp screen
            dispatch(setUserRefresh())
            dispatch(setAddWishlist(body));
            // Toastify.success('Product added in wishlist successfuly');

            dispatch(setRefresh());
        }
        return data.data

    } catch (err) {
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const updateWishlist = createAsyncThunk('updateWishlist', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.updateWishlist(body);

        if (status === 200) {
            // render otp screen
            dispatch(setUpdateWishlist(body));
            // Toastify.success(data.data.message);
            dispatch(setRefresh());
        }
        return data.data

    } catch (err) {
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const deleteWishlist = createAsyncThunk('deleteWishlist', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.deleteWishlist(body);

        if (status === 200) {
            // render otp screen
            dispatch(setDeleteWishlist(body));
            // Toastify.success(data.data.message);
            dispatch(setRefresh());
        }
        return data.data

    } catch (err) {
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const addCarts = createAsyncThunk('addCarts', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.addCarts(body);

        if (status === 200) {
            if (data.message === 'You already added this product in the cart!') {
                Toastify.warning(data.message);
            } else {
                // Toastify.success(data.message);
                dispatch(setAddCarts(body));
            }
            dispatch(setUserRefresh());
            dispatch(setRefresh());
        }
        return data.data

    } catch (err) {
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const wishlistSlice = createSlice({
    name: "wishlist",
    initialState,
    reducers: {

        setAllWishlist: (state, action) => {
            state.wishlistData = action.payload
        },

        setAddWishlist: (state, action) => {
            state.addWishlistData = action.payload
        },
        setUpdateWishlist: (state, action) => {
            state.updateWishlistData = action.payload
        },
        setDeleteWishlist: (state, action) => {
            state.deleteWishlistData = action.payload
        },
        setAddCarts: (state, action) => {
            state.addCartsData = action.payload
        },
        setRefresh: (state) => {
            state.isRefresh = !state.isRefresh
        },

    },
    extraReducers: (builder) => {

        // setAllProducts
        builder.addCase(getAllWishlist.pending, (state) => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getAllWishlist.fulfilled, (state, action) => {
            state.isLoading = false
            state.wishlistData = action.payload
        })
        builder.addCase(getAllWishlist.rejected, (state, action) => {
            state.isLoading = false
            state.errorMsg = action.payload
        })


    }
})

export const {
    setRefresh,
    setAllWishlist,
    setAddWishlist,
    setUpdateWishlist,
    setDeleteWishlist,
    setAddCarts,
} = wishlistSlice.actions

export default wishlistSlice.reducer;